function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "5ce61fc9cd"
}, React.createElement("path", {
  d: "M 15.476562 15.476562 L 794.726562 15.476562 L 794.726562 794.726562 L 15.476562 794.726562 Z M 15.476562 15.476562 ",
  clipRule: "nonzero"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#5ce61fc9cd)"
}, React.createElement("path", {
  fill: "#2a3948",
  d: "M 405.21875 15.542969 C 620.429688 15.542969 794.894531 189.996094 794.894531 405.21875 C 794.894531 620.421875 620.429688 794.882812 405.21875 794.882812 C 190.003906 794.882812 15.535156 620.421875 15.535156 405.21875 C 15.535156 189.996094 190.003906 15.542969 405.21875 15.542969 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M 566.277344 390.1875 L 354.9375 238.285156 C 343.921875 230.363281 329.386719 229.253906 317.285156 235.40625 C 305.183594 241.566406 297.523438 253.953125 297.4375 267.527344 L 295.445312 568.53125 C 295.359375 582.113281 302.855469 594.597656 314.875 600.914062 C 320.109375 603.664062 325.816406 605.042969 331.523438 605.078125 C 338.914062 605.128906 346.277344 602.914062 352.558594 598.523438 L 565.878906 449.433594 C 575.535156 442.6875 581.3125 431.6875 581.390625 419.910156 C 581.46875 408.132812 575.832031 397.050781 566.277344 390.1875 ",
  fillOpacity: 1,
  fillRule: "nonzero"
});

var SvgPlayIcon = function SvgPlayIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlayIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play_icon.ffc97cce.svg";
export { ForwardRef as ReactComponent };